export default __webpack_public_path__ + "static/media/cyclops_7.e9e07b36.svg";